export enum OfficeOfferService {
  RJ45 = 'rj45',
  DEDICATED_NETWORK = 'dedicated_network',
  ACCESS_SERVER = 'access_server',
  AC = 'ac',
  PRIVATE_KITCHEN = 'private_kitchen',
  HOUSEHOLD = 'household',
  TEA_ROOM = 'tea_room',
  SHOWER = 'shower',
  PRINTER = 'printer',
  TABLES_CHAIRS = 'tables_chairs',
  PRIVATE_SANITARY = 'private_sanitary',
  VIDEOCONFERENCE_EQUIPMENT = 'videoconference_equipment',
  STORAGE_POINT = 'storage_point',
  PARKING = 'parking',
  PRIVATE_MEETING_ROOM = 'private_meeting_room',
  PRIVATE_PHONE_BOX = 'private_phone_box',
  LOCKER = 'locker',
  SEPARATE_ENTRANCE = 'separate_entrance',
}
